// extracted by mini-css-extract-plugin
export var pillWrapper = "_q2-0";
export var showOverflow = "_q2-1";